import Loader from "../../shared/Loader";
import FloatUp from "../../shared/FloatUp";
import AdminImageCard from "../../shared/AdminImageCard";
import { Link } from "react-router-dom";
import axios from "axios";

import AppContext from "../../../context/Context";
import { getImages } from "../../../context/Actions";

import { useEffect, useContext } from "react";
const BASE_URL = process.env.REACT_APP_BASE_URL;

async function handleImageDelete(id) {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Are you sure you want to delete this image?")) {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("You must be logged in to delete an image");
            return;
        }
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.delete(
            `${BASE_URL}/gallery/${id}`,
            config
        );
        if (response.data.success) {
            alert("Image deleted successfully");
            // I have Search For an Alternative instead of reloading page
            window.location.reload();
        } else {
            alert("Something went wrong");
        }
    } else {
        return;
    }
}

function AdminGallery() {
    const { isLoading, images, dispatch } = useContext(AppContext);

    useEffect(() => {
        dispatch({ type: "SET_LOADING" });
        const getImagesList = async () => {
            const fetchedImages = await getImages();
            dispatch({ type: "GET_IMAGES", payload: fetchedImages });
        };
        getImagesList();
    }, [dispatch]);

    if (isLoading) return <Loader />;
    return (
        <section className="section">
            <div className="level">
                <div className="level-left">
                    <div className="level-item">
                        <h2 className="title is-3">All Images</h2>
                    </div>
                </div>
                <div className="level-right">
                    <div className="level-item">
                        <Link
                            className="button is-light is-medium"
                            to="/admin/gallery/new"
                        >
                            Add Image
                        </Link>
                    </div>
                </div>
            </div>
            <div className="container my-6">
                <FloatUp>
                    <div
                        className="columns is-multiline"
                        style={{ width: "auto" }}
                    >
                        {images.map((image) => {
                            return (
                                <div
                                    key={image._id}
                                    className="column is-one-third"
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <AdminImageCard
                                            id={image._id}
                                            imageUrl={image.imgUrl}
                                            title={image.title}
                                            alt={image.altText}
                                            date={image.date}
                                            handleImageDelete={
                                                handleImageDelete
                                            }
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </FloatUp>
            </div>
        </section>
    );
}

export default AdminGallery;
